import { render, staticRenderFns } from "./PanMenu.vue?vue&type=template&id=195f15bd&scoped=true&"
import script from "./PanMenu.vue?vue&type=script&lang=js&"
export * from "./PanMenu.vue?vue&type=script&lang=js&"
import style0 from "./PanMenu.vue?vue&type=style&index=0&id=195f15bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195f15bd",
  null
  
)

export default component.exports